export function setAvailabilities(data) {
  return {
    type: 'SET_AVAILABILITIES',
    payload: data,
  }
}

export function setActiveAvailability(availId) {
  return {
    type: 'SET_ACTIVE_AVAILABILITY',
    payload: {availId},
  }
}
